<template>
  <div class="right gerenxinxi">
    <div class="common-tab-heads grzxxx_tab" v-if="false">
      <!--        <div class="line"></div>-->
      <div class="nav">
        <span
          class="grzxxx_tabs"
          :class="item.id == currentNav ? 'active' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="currentNavChange(item)"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <div class="grxx-container" v-if="currentNav == 'jbxx'">
      <div
        class="rczp-title"
        style="
          font-size: 20px;
          color: #4caff7;
          margin: 10px auto;
          display: flex;
          justify-content: center;
        "
      >
        基本信息
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">证件照：</span>
          <el-upload
            :action="uploadImgUrl"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload"
            :headers="headers"
            :limit="1"
          >
            <img
              v-if="studentInfo.headUrl"
              :src="studentInfo.headUrl"
              class="avatar"
            />
            <i
              v-if="!studentInfo.headUrl"
              class="el-icon-plus avatar-uploader-icon"
            ></i>
            <div
              slot="tip"
              class="el-upload__tip"
              style="text-align: center; font-size: 14px; color: #f49d1a"
            >
              温馨提示:请上传免冠证件照（图片大小2MB以内）
            </div>
          </el-upload>
        </div>
      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">姓名：</span>
          <input
            placeholder="请输入"
            v-model="studentInfo.name"
            class="rczp-form-input"
          />
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">性别：</span>
          <div>
            <div>
              <input
                type="radio"
                value="2"
                name="radios"
                v-model="studentInfo.gender"
                class="rczp-form-radio"
              /><label for="woman" class="rczp-radio-text">女</label>
              <input
                type="radio"
                value="1"
                name="radios"
                v-model="studentInfo.gender"
                class="rczp-form-radio"
              /><label for="man" class="rczp-radio-text">男</label>
            </div>
          </div>
        </div>
      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">出生年月：</span>
          <el-date-picker
            style="width: 160px !important"
            v-model="studentInfo.birthday"
            type="date"
            placeholder="选择日期"
          >
            <!-- disabled -->
          </el-date-picker>
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">联系电话：</span>
          <input
            placeholder="请输入"
            v-model="studentInfo.telephone"
            class="rczp-form-input disabled"
          />
          <!-- readonly -->
        </div>
      </div>

      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">证件类型：</span>
          <select class="mySelectorDrop" v-model="studentInfo.cardType">
            <option value="">请选择</option>
            <option value="1">身份证</option>
          </select>
        </div>
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">身份证号：</span>
          <input
            placeholder="请输入"
            v-model="studentInfo.cardNum"
            class="rczp-form-input"
            readonly
          />
        </div>
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">邮箱：</span>
          <input
            placeholder="请输入"
            v-model="studentInfo.email"
            class="rczp-form-input"
          />
        </div>
      </div>
      <div class="rczp-row">
        <div class="rczp-col rczp-col-2">
          <span class="rczp-form-label">个人评价：</span>
          <textarea
            placeholder="请输入个人评价"
            rows="4"
            maxlength="200"
            v-model="studentInfo.introduce"
          ></textarea>
        </div>
      </div>
      <div class="btn-box">
        <button
          type="button"
          class="common-btn my-btn"
          @click="updateUserInfo()"
        >
          保存
        </button>
      </div>
    </div>
    <section class="jlxx_xmjl" v-if="currentNav == 'fj'">
      <div
        class="rczp-title"
        style="font-size: 20px; color: #4caff7; margin-bottom: 10px"
      >
        附件
      </div>
      <div
        slot="tip"
        class="el-upload__tip"
        style="text-align: center; font-size: 18px; color: #f49d1a"
        v-if="fjFormShow"
      >
        温馨提示:学历毕业证,学信网《教育部学籍在线验证报告》,学士学位证书,身份证正反面为必传文件。
        <br />报名应届毕业生岗位的2024年毕业的考生，上传毕业证书及学位证书时，均在纸上手写“本人为应届毕业生”上传即可。
      </div>
      <div class="append_content" v-if="!fjFormShow">
        <div class="appendList" v-for="(item, index) in fjList" :key="index">
          <div class="append_image" @click="downloadFile(item)">
            <img
              style="width: 100%; height: 100%"
              v-if="
                item.appendUrl.indexOf('jpg') > 0 ||
                item.appendUrl.indexOf('png') > 0 ||
                item.appendUrl.indexOf('jpeg') > 0
              "
              :src="item.appendUrl"
            />
            <img
              v-if="
                item.appendUrl.indexOf('doc') > 0 ||
                item.appendUrl.indexOf('docx') > 0
              "
              src="@/assets/images/word.png"
            />
            <img
              v-if="
                item.appendUrl.indexOf('xls') > 0 ||
                item.appendUrl.indexOf('xlsx') > 0
              "
              src="@/assets/images/excel.jpg"
            />
            <img
              v-if="item.appendUrl.indexOf('pdf') > 0"
              src="@/assets/images/pdf.jpeg"
            />
          </div>
          <div class="append_name">{{ item.name }}</div>
          <div class="append_btn jlxx_moudle_button showEdit">
            <span @click="delForm(item)">删除</span
            ><span @click="changeFormShow(item)">修改</span>
            <span @click="onDownloadFile(item.appendUrl, item.name)">下载</span>
          </div>
        </div>
      </div>
      <div class="xmjl_moudle">
        <div class="jlxx_form" v-if="fjFormShow">
          <form id="xmjl_form">
            <div class="rczp-row">
              <div class="rczp-col rczp-col-2">
                <span class="rczp-form-label required">附件名称</span>
                <select v-model="fjForm.type">
                  <option selected disabled hidden value=""></option>
                  <option value="学历毕业证">学历毕业证</option>
                  <option value="学信网《教育部学籍在线验证报告》">
                    学信网《教育部学籍在线验证报告》
                  </option>
                  <option value="学士学位证书">学士学位证书</option>
                  <option value="身份证正反面">身份证正反面</option>
                  <option value="职业资格证书">职业资格证书</option>
                  <option value="其他">其他</option>
                </select>
              </div>
              <div class="rczp-col rczp-col-2" v-if="fjForm.type == '其他'">
                <span class="rczp-form-label required">附件名称</span>
                <input
                  placeholder="请输入"
                  class="rczp-form-input"
                  type="text"
                  maxlength="50"
                  v-model="fjForm.name"
                />
              </div>
            </div>
            <div class="rczp-row">
              <div class="rczp-col rczp-col-2">
                <span class="rczp-form-label required">附件类型</span>
                <select v-model="fjForm.fileType">
                  <option selected disabled hidden value=""></option>
                  <option value="1">图片</option>
                  <option value="2">文件</option>
                </select>
              </div>
            </div>
            <div class="rczp-row" v-if="fjForm.fileType == 1">
              <div class="rczp-col rczp-col-1">
                <span class="rczp-form-label required" style="width: 10%"
                  >附件：</span
                >
                <el-upload
                  class="avatar-uploader"
                  :action="uploadImgUrl"
                  :show-file-list="false"
                  :on-success="fjHandleUploadSuccess"
                  :before-upload="handleBeforeUploadFJ"
                  :headers="headers"
                  :limit="1"
                  accept=".jpg,.png,.jpeg"
                >
                  <img
                    v-if="fjForm.appendUrl"
                    :src="fjForm.appendUrl"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="rczp-row-file" v-if="fjForm.fileType == 2">
              <div class="rczp-row-file-col">
                <span class="rczp-form-label required" style="width: 10%"
                  >附件：</span
                >
                <el-upload
                  class="upload-demo"
                  :action="uploadImgUrl"
                  :on-success="fjHandleUploadSuccess"
                  :before-upload="handleBeforeUploadFJ"
                  :headers="headers"
                  :file-list="fjFileList"
                  :limit="1"
                  accept=".jpg,.png,.jpeg,.pdf"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传pdf文件，且大小不能超过2MB
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="jlxx_btn">
              <button
                type="button"
                class="common-btn my-btn"
                style="background-color: rgba(241, 83, 82, 1)"
                @click="moudleCancel()"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;&nbsp;
              </button>
              <button
                type="button"
                class="common-btn my-btn"
                @click="moudleOk()"
              >
                保存更新
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        class="grzx_common_add_button jlxx_add_button"
        @click="changeFormShow(null)"
      >
        + 添加附件
      </div>
    </section>
  </div>
</template>

<script>
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import axios from "axios";
import request from "@/request";
export default {
  data() {
    return {
      studentInfo: {
        cardType: "",
        headUrl: "",
      },
      uploadImgUrl: request.uploadFile, // 上传的图片服务器地址
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      headUrlList: [],
      fileList: [],
      fjFileList: [],
      userInfo: {},
      uploadInst: null,
      cropperObj: null,
      cutImage: false,
      fileType: ["png", "jpg", "jpeg", "xlsx", "xls", "doc", "docx", "pdf"],
      uploadFileType: ["jpg"],
      currentNav: "jbxx",
      navList: [
        { name: "基本信息", id: "jbxx" },
        // { name: "附件", id: "fj" },
      ],
      fjList: [],
      fjForm: {},
      fjFormShow: false,
    };
  },
  activated() {
    let _this = this;
    _this.getUserInfo();
    _this.getResume();
  },
  computed: {
    // 手机号验证
    validPhoneNumber() {
      // 定义手机号码的正则表达式，可以根据需要进行调整
      var regex = /^1[3-9]\d{9}$/;
      return regex.test(this.studentInfo.telephone);
    },
  },
  methods: {
    currentNavChange(val) {
      let _this = this;
      _this.currentNav = val.id;
    },
    getResume() {
      let _this = this;
      _this.$api.employee
        .getResume()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.fjList = res.data.fj;
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getUserInfo() {
      let _this = this;
      _this.$api.employee
        .getUserInfo()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.studentInfo = res.data;
            console.log("res", _this.studentInfo);
            // _this.userInfo = res.data.user;
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    uploadPic(val) {
      $("#uploadImg").attr("data-type", val);
      $("#uploadImg").click();
    },
    uploadHead() {
      $("#imgReader").click();
      if (this.cropperObj) {
        this.cropperObj.destroy();
      }
    },
    loadingImg(event) {
      let _this = this;
      _this.cutImage = true;
      _this.$layer.open({
        title: "图片剪裁",
        type: 1,
        skin: "custom-layer",
        content: $("#cutImage"),
        area: ["680px", "580px"],
        btn: ["确认"],
        success: () => {
          //读取上传文件
          let reader = new FileReader();
          if (event.target.files[0]) {
            //readAsDataURL方法可以将File对象转化为data:URL格式的字符串（base64编码）
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e) => {
              let dataURL = reader.result;
              //将img的src改为刚上传的文件的转换格式
              document.querySelector("#cropImg").src = dataURL;
              const image = document.getElementById("cropImg");
              image.onload = () => {
                if (image.width > image.height) {
                  image.style.width = "480px";
                } else {
                  image.style.height = "480px";
                }
                //创建cropper实例
                _this.cropperObj = new Cropper(image, {
                  aspectRatio: 16 / 16,
                  viewMode: 0,
                  minContainerWidth: 480,
                  minContainerHeight: 480,
                  dragMode: "move",
                  preview: [
                    document.querySelector(".previewBox"),
                    document.querySelector(".previewBoxRound"),
                  ],
                });
              };
            };
          }
        },
        yes: (index) => {
          _this.cropperObj
            .getCroppedCanvas({
              maxWidth: 4096,
              maxHeight: 4096,
              fillColor: "#fff",
              imageSmoothingEnabled: true,
              imageSmoothingQuality: "high",
            })
            .toBlob((blob) => {
              //然后调用浏览器原生的toBlob方法将canvas数据转换成blob数据
              //之后就可以愉快的将blob数据发送至后端啦，可根据自己情况进行发送，我这里用的是axios
              const formData = new FormData();
              // 第三个参数为文件名，可选填.
              formData.append("file", blob, "example.png");
              let config = {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              };
              axios
                .post(
                  `${request.uploadFile}&Authentication=${_this.$cookies.get(
                    _this.$commons.User.Authentication
                  )}`,
                  formData,
                  config
                )
                .then((response) => {
                  if (
                    response.data.errorCode == _this.$commons.RespCode.success
                  ) {
                    _this.userInfo.headUrl = response.data.data.path;
                  } else {
                    _this.$layer.alert("图片上传失败");
                  }
                  document.querySelector("#cropImg").src = "";
                  _this.$layer.close(index);
                  _this.cutImage = false;
                })
                .catch((err) => {});
            });
        },
        cancel: (index) => {
          document.querySelector("#cropImg").src = "";
          _this.$layer.close(index);
          _this.cutImage = false;
        },
      });
    },
    picUpload() {
      let _this = this;
      _this.uploadInst.reload({
        before: function () {
          _this.$layer.load(0, { shade: false });
        },
        done: function (res) {
          if (res.errorCode == _this.$commons.RespCode.needLogin) {
            _this.$router.push({
              path: "/login",
            });
          } else if (res.errorCode == _this.$commons.RespCode.success) {
            let type = $("#uploadImg").attr("data-type");
            _this.studentInfo[type] = res.data.path;
            _this.$forceUpdate();
          } else {
            _this.$layer.alert("图片上传失败");
          }
          _this.$layer.closeAll("loading");
        },
        error: function () {
          _this.$layer.closeAll("loading");
        },
      });
    },

    // 上传成功回调
    handleUploadSuccess(res, file) {
      let _this = this;
      console.log("handleUploadSuccess", res);
      console.log("file", file);
      // this.fileList.push({ name: res.data.url, url: res.data.url });
      _this.studentInfo.headUrl = res.data.url;
      _this.headUrlList.push(file);
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },
    // 上传成功回调
    fjHandleUploadSuccess(res) {
      let _this = this;
      this.fjFileList = [];
      this.fjFileList.push({ name: res.data.url, url: res.data.url });
      _this.fjForm.appendUrl = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      const isJPG = file.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
        return false;
      }
      if (!isImg) {
        this.$modal.msgError(
          `文件格式不正确, 请上传${this.uploadFileType.join("/")}格式文件!`
        );
        return false;
      }
      const isLt = file.size / 1024 / 1024 < 2;
      if (!isLt) {
        this.$modal.msgError(`上传头像图片大小不能超过 2MB!`);
        return false;
      }

      this.$modal.loading("正在上传，请稍候...");
    },
    handleBeforeUploadFJ(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }
      if (!isImg) {
        this.$modal.msgError(
          `文件格式不正确, 请上传${this.uploadFileType.join("/")}格式文件!`
        );
        return false;
      }
      const isLt = file.size / 1024 / 1024 < 2;
      if (!isLt) {
        this.$modal.msgError(`上传头像图片大小不能超过 2MB!`);
        return false;
      }

      this.$modal.loading("正在上传，请稍候...");
    },
    updateUserInfo() {
      let _this = this;
      if (!_this.studentInfo.headUrl) {
        _this.$layer.alert("请上传个人头像!");
        return;
      }
      if (!_this.studentInfo.name) {
        _this.$layer.alert("请输入姓名!");
        return;
      } else {
        let nameReg = new RegExp("^[\u4e00-\u9fa5]{0,}$");
        if (!nameReg.test(_this.studentInfo.name)) {
          _this.$layer.alert("姓名格式不正确!");
          return;
        }
      }
      if (!_this.studentInfo.gender) {
        _this.$layer.alert("请选择性别!");
        return;
      }
      if (!_this.studentInfo.birthday) {
        _this.$layer.alert("请选择出生年月!");
        return;
      }
      // if (!_this.studentInfo.cardType) {
      //   _this.$layer.alert("请选择证件类型!");
      //   return;
      // }
      if (!_this.validPhoneNumber) {
        _this.$layer.alert("请输入正确的手机号!");
        return false;
      } else if (!_this.studentInfo.cardNum) {
        _this.$layer.alert("请输入身份证号码!");
        return;
      } else if (!_this.$util.checkIdCard(_this.studentInfo.cardNum)) {
        _this.$layer.alert("身份证号不正确");
        return false;
      }
      if (!_this.studentInfo.email) {
        _this.$layer.alert("请输入邮箱!");
        return;
      } else {
        // var emailData = ['qq.com', '163.com'];
        // for (const suffix of emailData) {
        //     let myemail = new RegExp(
        //         "^\\w+([-+.]\\w+)*@"+suffix
        //     );
        // }
        // if (!myemail.test(_this.studentInfo.email)) {
        //     _this.$layer.alert("邮箱格式错误!");
        //     return;
        // }
        // let myemail = new RegExp(
        //     "^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$"
        // );
        let myemail = new RegExp(
          // 只判断是不是 qq 邮箱
          //   "^\\w+@qq\\.com$"
          // 判断是不是 qq || 163 邮箱
          //   "^\\w+@(qq\\.com|163\\.com)$"
          // 中国市面上大部分邮箱格式
          "^(([a-zA-Z0-9]+[_|\\.|-]?)*)+[a-zA-Z0-9]@([\\w]+\\.(com|net|cn|org|edu|gov|mil|biz|info|mobi|name|pro|asia|local))+$"
        );
        if (!myemail.test(_this.studentInfo.email)) {
          _this.$layer.alert("邮箱格式错误!");
          return;
        }
      }
      let param = {
        id: _this.studentInfo.id,
        telephone: _this.studentInfo.telephone,
        headUrl: _this.studentInfo.headUrl,
        email: _this.studentInfo.email,
        gender: _this.studentInfo.gender,
        name: _this.studentInfo.name,
        cardNum: _this.studentInfo.cardNum,
        introduce: _this.studentInfo.introduce,
      };
      _this.$api.employee
        .updateUserInfo(param)
        .then((res) => {
          _this.$layer.alert(res.msg);
          if (res.code == _this.$commons.RespCode.success) {
            _this.$emit("getUser", _this.userInfo);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    downloadFile(item) {
      let _this = this;
      if (item.fileType == 1) {
        _this.$layer.open({
          type: 2,
          title: false,
          closeBtn: 0,
          area: ["80%", "80%"],
          skin: "layui-layer-nobg", //没有背景色
          shadeClose: true,
          content: item.appendUrl,
        });
      }
    },
    onDownloadFile(url, fileName) {
      this.getBlob(url, (blob) => {
        this.saveAs(blob, fileName);
      });
    },
    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },

    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    },
    delForm(item) {
      let _this = this;
      let parm = {
        id: item.id,
      };
      _this.$layer.confirm(
        "确认要执行删除操作吗?",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          _this.$api.append
            .deleteById(parm)
            .then((res) => {
              _this.$layer.alert(res.msg);
              _this.fjForm = {};
              _this.fjFormShow = false;
              _this.getResume();
            })
            .catch(() => {})
            .finally(() => {});

          _this.$layer.close(index);
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
    changeFormShow(item) {
      let _this = this;
      _this.fjFormShow = true;
      _this.fjFileList = [];
      if (item) {
        _this.getFj(item);
      } else {
        _this.fjForm = {};
      }
    },
    moudleCancel() {
      let _this = this;
      _this.fjFormShow = false;
    },
    moudleOk() {
      let _this = this;
      _this.addOrUpdateFj();
    },
    addOrUpdateFj() {
      let _this = this;
      if (!_this.fjForm.type) {
        _this.$layer.alert("请选择附件名称");
        return;
      }
      if (_this.fjForm.type == "其他" && !_this.fjForm.name) {
        _this.$layer.alert("请输入附件名称");
        return;
      }
      if (!_this.fjForm.appendUrl) {
        _this.$layer.alert("请上传附件");
        return;
      }
      if (_this.fjForm.type != "其他") {
        _this.fjForm.name = _this.fjForm.type;
      }
      if (_this.fjForm.id) {
        _this.$api.append
          .edit(_this.fjForm)
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.fjForm = {};
            _this.fjFormShow = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$api.append
          .add(_this.fjForm)
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.fjForm = {};
            _this.fjFormShow = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    getFj(item) {
      let _this = this;
      let parm = {
        id: item.id,
      };
      _this.fileList = [];
      _this.$api.append
        .getById(parm)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.fjForm = res.data;
            _this.fileList.push({
              name: res.data.appendUrl.substring(
                res.data.appendUrl.lastIndexOf("/") + 1,
                res.data.appendUrl.length
              ),
              url: res.data.appendUrl,
            });
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>

<style>
.required:before {
  content: "* ";
  color: red;
}

.cropImgContent {
  width: 480px;
  float: left;
}

.cropImgContent img {
  box-shadow: 0 0 5px #adadad;
}

.previewContent {
  float: left;
  margin-left: 52px;
}

.previewContent .previewText {
  font-size: 16px;
  margin-top: 16px;
  text-align: center;
}

.previewContent .previewBox,
.previewContent .previewBoxRound {
  box-shadow: 0 0 5px #adadad;
  width: 100px;
  height: 100px;
  margin-top: 20px;
  overflow: hidden;
  /*这个超出设置为隐藏很重要，否则就会整个显示出来了*/
}

.previewContent .previewBoxRound {
  border-radius: 50%;
  /*设置为圆形*/
  margin-top: 40px;
}

body .custom-layer .layui-layer-title {
  background: #be1a21;
  color: #fff;
  border: none;
}

body .custom-layer .layui-layer-btn {
  border-top: 1px solid #e9e7e7;
}

body .custom-layer .layui-layer-btn a {
  background: #be1a21;
  border-color: #be1a21;
}

body .custom-layer .layui-layer-btn .layui-layer-btn1 {
  background: #be1a21;
}

select {
  width: 300px;
  background: #f8f8f8;
  border: 1px solid #ededed;
  padding: 8px 0 8px 10px;
  border-radius: 4px;
}

.el-upload__input {
  display: none !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.rczp-row textarea {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  width: 100%;
  padding: 11px 0 5px 12px;
  margin-top: 10px;
  resize: none;
  outline: none;
  border: none;
  border-bottom: 1px solid #ededed;
}
.rczp-row-file {
  display: flex;
  height: auto;
}

select {
  width: 300px;
  background: #f8f8f8;
  border: 1px solid #ededed;
  padding: 8px 0 8px 10px;
  border-radius: 4px;
}

.append_content {
  margin: 40px auto !important;
  width: 890px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.appendList {
  display: flex;
  flex-flow: column;
  margin-right: 20px;
  margin-bottom: 20px;
  width: 270px;
  height: 206px;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgb(208 208 208 / 50%);
  border-radius: 10px;
  transition: all 0.2s;
  padding-top: 10px;
}

.appendList:hover {
  cursor: pointer;
  box-shadow: 10px 6px 40px rgb(208 208 208);
}

.append_image {
  height: 128px;
  width: 250px;
  /* background-color: #00F7DE; */
  margin: auto;
}

.append_image img {
  height: 100%;
  max-width: 100%;
}

.append_name {
  height: 30px;
  width: 250px;
  margin: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.2s;
}

.append_btn {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  align-content: center;
  padding: 5px;
}

.appendList:hover .append_name {
  color: #409eff !important;
  transform: scale(1.02);
  font-weight: 600;
}

.showEdit {
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/mine/mineInfo.vue